export interface ChapterProgress {
  progress: number;
  total_pages: number;
  specialization?: unknown;
}

/**
 * Returns the diploma completion percentage (0-100). Only foundational chapters count towards the diploma,
 * specialization chapters are excluded.
 */
export function calculateDiplomaProgress(chapters: ChapterProgress[] = []) {
  const foundationalChapters = chapters.filter((chapter) => {
    return !chapter.specialization;
  });

  const totalProgress = foundationalChapters.reduce((sum, chapter) => {
    return sum + chapter.progress;
  }, 0);
  const totalPages = foundationalChapters.reduce((sum, chapter) => {
    return sum + chapter.total_pages - 1;
  }, 0);

  if (totalPages <= 0) return 0;

  return Math.min(Math.floor((totalProgress / totalPages) * 100), 100);
}
